export default __webpack_public_path__ + "static/dIrcUWLo-16ebd707418b88dc4ee41f7441091ec4.svg";